import React, { useState } from "react";
import styles from "./Date.module.scss";
import { Controller } from "react-hook-form";
import withLabelAndError from "../withLabelAndError";
import { combineClasses } from "@/lib/utils";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { IconButton, InputAdornment } from "@mui/material";
import CalendarIcon from "@/components/SVGComponents/ModalIcons/CalendarIcon";

const DateInput: React.FC<InputControlProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    placeholder,
    error,
    className,
    ...rest
  } = props;

  const [open, setOpen] = useState(false);

  const pickerSlotProps = {
    sx: {
      "& .MuiPickersDay-root.Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
      "& .MuiPickersDay-root.Mui-selected:hover": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
      },
      "& .MuiPickersDay-root.MuiPickersDay-today": {
        borderColor: "rgb(var(--secondary-color)) !important",
      },
      "& .MuiPickersYear-yearButton.Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
      "& .MuiPickersMonth-monthButton.Mui-selected": {
        backgroundColor: "rgb(var(--secondary-color)) !important",
        color: "white !important",
      },
    },
  };

  const renderDatePicker = (field: any = {}) => (
    <DatePicker
      {...field}
      value={field.value ? dayjs(field.value) : null}
      format="YYYY/MM/DD"
      minDate={dayjs()}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      onChange={(date: Dayjs | null) => {
        field.onChange(date ? date.format("YYYY-MM-DD") : null);
        setOpen(false);
      }}
      {...rest}
      slotProps={{
        ...(rest as any).slotProps,
        popper: pickerSlotProps,
        desktopPaper: pickerSlotProps,
        mobilePaper: pickerSlotProps,
        textField: {
          label: "",
          fullWidth: true,
          placeholder,
          error: !!error,
          helperText: error?.message,
          className: combineClasses(styles.inputRoot, className),
          onClick: () => setOpen(true),

          InputProps: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  onClick={() => setOpen(true)}
                  tabIndex={-1}
                >
                  <CalendarIcon height="18" width="18" />
                  {/* OR your custom SVG */}
                </IconButton>
              </InputAdornment>
            ),
          },
        },
      }}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        rules={validations}
        name={name}
        render={({ field }) => renderDatePicker(field)}
      />
    );
  } else {
    const field = register?.(name, validations);
    return renderDatePicker(field);
  }
};

const DateInputWithLabelAndError = withLabelAndError(
  DateInput as WithLabelAndErrorComponent
);

export default DateInputWithLabelAndError;
export { DateInput };
